import { useState } from 'react';
import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoryTable } from '../components/HistoryTable';

type HistoryTab = 'scan' | 'batch';

export function VideoHistoryPage() {
  const [activeTab, setActiveTab] = useState<HistoryTab>('scan');

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-primary-900">Video History</h1>
        <p className="text-sm text-primary-500 mt-1">
          {activeTab === 'scan'
            ? 'Completed and failed turntable-video scans. Use the row actions to view the video, copy the service response, or re-run with the current settings.'
            : 'Finished CSV batches. A batch appears here once every one of its scans has completed or failed.'}
        </p>
      </div>

      <div className="flex border-b border-primary-100">
        {([
          { id: 'scan', label: 'Scan History' },
          { id: 'batch', label: 'Batch History' },
        ] as const).map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2.5 text-sm font-medium transition-colors relative ${
              activeTab === tab.id
                ? 'text-primary-900'
                : 'text-primary-500 hover:text-primary-700'
            }`}
          >
            {tab.label}
            {activeTab === tab.id && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600 rounded-t" />
            )}
          </button>
        ))}
      </div>

      {activeTab === 'batch' ? <BatchHistoryTable /> : <HistoryTable />}
    </div>
  );
}
